export enum AccountType {
    RETAIL = 'RETAIL',
    FABRICATOR = 'FABRICATOR',
    INSTALLER = 'INSTALLER',
    ARCHITECT = 'ARCHITECT',
    DESIGNER = 'DESIGNER',
    DISTRIBUTOR = 'DISTRIBUTOR',
}

export namespace AccountType {
    export function isCtop(accountType: AccountType|null): boolean {
        return accountType === AccountType.DESIGNER || accountType === AccountType.ARCHITECT;
    }
}
